import { render, staticRenderFns } from "./cetak_massal.vue?vue&type=template&id=568ad771&"
import script from "./cetak_massal.vue?vue&type=script&lang=js&"
export * from "./cetak_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports